import { restGet, restPost, restPut } from "apiCommandsExecutor/rest";

import { AccountDto, ConfirmationCodeSentDto } from "./restModels";
import { SetPasswordRequestDto } from "./restRequests";

export const getAccount = () => restGet<AccountDto>("/account");

export const sendConfirmationCode = () =>
    restPost<ConfirmationCodeSentDto>("/account/confirmation-code");

export const setPassword = (body: SetPasswordRequestDto) =>
    restPut<AccountDto>("/account/password", body);
